<template>
  <div>
    <v-autocomplete
      v-model="searchText"
      @change="onSearch"
      hide-details="auto"
      class="datainput justify-content-end align-self-center pb-1"
      :items="serviceOrder"
      dense
      outlined
      clearable
      :label="$t('select_label')"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  data() {
    return {
      searchText: null,
      serviceOrder: [],
    };
  },
  props: {
    columnHeader: String,
    onCustomEvent: Function,
  },
  mounted() {
    this.fetchServiceOrder();
    if (sessionStorage.getItem("serviceOrder")) {
      this.searchText = sessionStorage.getItem("serviceOrder");
    }
    eventBus.$on("clear-filters", this.clearFilters);
  },
  methods: {
    clearFilters() {
      this.searchText = null;
      const columnHeader = this.params.columnHeader;

      if (columnHeader == "serviceOrder") {
        sessionStorage.removeItem("serviceOrder");
      }
    },
    onSearch() {
      const searchText = this.searchText;
      const columnHeader = this.params.columnHeader;
      if (
        columnHeader == "serviceOrder" &&
        searchText !== undefined &&
        searchText !== null &&
        searchText.trim() !== ""
      ) {
        sessionStorage.setItem("serviceOrder", searchText);
      } else {
        sessionStorage.removeItem("serviceOrder");
      }
      this.$parent.$listeners.onFilterChanged(columnHeader, searchText);
    },
    fetchServiceOrder() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/saleslist/get-service-order")
        .then(function (response) {
          _this.serviceOrder = response.data;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
  },
};
</script>
